<div class="page-holder" *ngIf="!loading && !error">
  <div class="header mat-elevation-z4">
    <div class="title">Validador de Entidades</div>
    <div class="subtitle" *ngIf="loading">{{loading}}</div>
    <div class="subtitle" *ngIf="!loading">{{entity.nickname}}</div>

    <button mat-icon-button  class="message-button" *ngIf="!isValidator" (click)="close()">
      <mat-icon>clear</mat-icon>
    </button>

    <button mat-icon-button class="message-button" *ngIf="isValidator" (click)="showAlertBox()">
      <mat-icon>message</mat-icon>
    </button>
  </div>

  <!-- validation form -->
  <div class="content-holder" *ngIf="entityData && entityData.entity">

    <div class="content-grid">

      <div class="form-data">
        <mat-card class="group mat-elevation-z2" [ngClass]="{hidden: !!profileImage}">
          <div class="group-header">
            <div class="group-avatar">
              <app-image-view [ngClass]="{validated:isFieldAproved('photo_url'), rejected:isFieldRejected('photo_url')}"
                [src]="entity.photo_url" radius="100%" imageSize="64" (click)="profileImage=entity">
              </app-image-view>
              <mat-icon *ngIf="entity.validated && !entity.validation_expires" class="verified-badge" color="accent">
                verified_user</mat-icon>
              <mat-icon *ngIf="!entity.validated && entity.validation_id" class="verified-badge" color="warn">
                report_problem</mat-icon>
              <mat-icon *ngIf="entity.validated && entity.validation_expires" class="verified-badge" color="warn">
                verified_user</mat-icon>
            </div>
            <div class="group-title">Dados Básicos</div>
          </div>

          <div class="group-data">

            <form *ngIf="form" [formGroup]="form" #cForm="ngForm" novalidate (keydown.enter)="$event.preventDefault()">

              <mat-form-field floatLabel="true" class="full-width"
                [ngClass]="{validated:isFieldAproved('name'), rejected:isFieldRejected('name')}" [color]="'primary'">
                <mat-label>Nome</mat-label>

                <input matInput [readonly]="entity.validated || !document" placeholder="nome" autocomplete="name"
                  formControlName="name" name="name">

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('name') && !isFieldRejected('name') && document"
                  (click)="rejectField('name')" [attr.aria-label]="'Rejeitar Nome'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-times" color="warn"></mat-icon>
                </button>

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('name') && !isFieldRejected('name') && document"
                  (click)="aproveField('name')" [attr.aria-label]="'Validar Nome'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-thumbs-up" color="primary"></mat-icon>
                </button>

                <button mat-icon-button matSuffix *ngIf="isFieldAproved('name')" [attr.aria-label]="'Nome Verificado'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-check" color="accent"></mat-icon>
                </button>

              </mat-form-field>

              <mat-form-field floatLabel="true" class="full-width">
                <mat-label>E-mail</mat-label>
                <input matInput readonly placeholder="email de contato" autocomplete="email" formControlName="email"
                  name="email">

              </mat-form-field>

              <!-- is_company == true -->
              <mat-form-field *ngIf="form.value.is_company" floatLabel="true" class="full-width"
                [ngClass]="{validated:isFieldAproved('document'), rejected:isFieldRejected('document')}">
                <mat-label>CNPJ</mat-label>
                <input matInput [readonly]="entity.validated || !document" mask="00.000.000/0000-00"
                  [showMaskTyped]="true" placeholder="CNPJ" autocomplete="document" formControlName="document"
                  name="document">

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('document') && !isFieldRejected('document') && document"
                  (click)="rejectField('document')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-times" color="warn"></mat-icon>
                </button>

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('document') && !isFieldRejected('document') && document"
                  (click)="aproveField('document')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-thumbs-up" color="primary"></mat-icon>
                </button>

                <button mat-icon-button matSuffix *ngIf="isFieldAproved('document')"
                  [attr.aria-label]="'Documento Verificado'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-check" color="accent"></mat-icon>
                </button>


              </mat-form-field>

              <!-- is_company == false -->
              <mat-form-field *ngIf="!form.value.is_company && !form.controls['document_foreigner']" floatLabel="true" class="full-width"
                [ngClass]="{validated:isFieldAproved('document'), rejected:isFieldRejected('document')}">
                <mat-label>CPF</mat-label>
                <input matInput [readonly]="entity.validated || !document" mask="000.000.000-00" [showMaskTyped]="true"
                  placeholder="CPF" autocomplete="off" formControlName="document" name="document">

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('document') && !isFieldRejected('document') && document"
                  (click)="rejectField('document')" [attr.aria-label]="'Rejeitar CPF'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-times" color="warn"></mat-icon>
                </button>

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('document') && !isFieldRejected('document') && document"
                  (click)="aproveField('document')" [attr.aria-label]="'Validar document'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-thumbs-up" color="primary"></mat-icon>
                </button>

                <button mat-icon-button matSuffix *ngIf="isFieldAproved('document')"
                  [attr.aria-label]="'Documento Verificado'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-check" color="accent"></mat-icon>
                </button>

              </mat-form-field>

              <mat-form-field *ngIf="!!form.controls['rg'] && !form.controls['document_foreigner']" floatLabel="true" class="full-width"
                [ngClass]="{validated:isFieldAproved('rg'), rejected:isFieldRejected('rg')}">
                <mat-label>RG</mat-label>
                <input matInput [readonly]="entity.validated || !document" placeholder="RG" autocomplete="rg"
                  formControlName="rg" name="rg">

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('rg') && !isFieldRejected('rg') && document"
                  (click)="rejectField('rg')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-times" color="warn"></mat-icon>
                </button>

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('rg') && !isFieldRejected('rg') && document"
                  (click)="aproveField('rg')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-thumbs-up" color="primary"></mat-icon>
                </button>

                <button mat-icon-button matSuffix *ngIf="isFieldAproved('rg')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-check" color="accent"></mat-icon>
                </button>

              </mat-form-field>

              <mat-form-field *ngIf="!!form.controls['document_foreigner']" floatLabel="true" class="full-width"
                [ngClass]="{validated:isFieldAproved('document_foreigner'), rejected:isFieldRejected('document_foreigner')}">
                <mat-label>ID Estrangeiro</mat-label>
                <input matInput [readonly]="entity.validated || !document" placeholder="document_foreigner" autocomplete="document_foreigner"
                  formControlName="document_foreigner" name="document_foreigner">

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('document_foreigner') && !isFieldRejected('document_foreigner') && document"
                  (click)="rejectField('document_foreigner')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-times" color="warn"></mat-icon>
                </button>

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('document_foreigner') && !isFieldRejected('document_foreigner') && document"
                  (click)="aproveField('document_foreigner')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-thumbs-up" color="primary"></mat-icon>
                </button>

                <button mat-icon-button matSuffix *ngIf="isFieldAproved('document_foreigner')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-check" color="accent"></mat-icon>
                </button>

              </mat-form-field>

              <mat-form-field floatLabel="true" class="full-width"
                [ngClass]="{validated:isFieldAproved('birth'), rejected:isFieldRejected('birth')}">
                <input matInput [readonly]="entity.validated || !document" placeholder="Nascimento"
                  formControlName="birth" name="birth" [matDatepicker]="birthPicker">


                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('birth') && !isFieldRejected('birth') && document"
                  (click)="rejectField('birth')">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-times" color="warn"></mat-icon>
                </button>

                <button mat-icon-button matSuffix
                  *ngIf="canValidate && !entity.validated && !isFieldAproved('birth') && !isFieldRejected('birth') && document"
                  (click)="aproveField('birth')" [attr.aria-label]="'Validar nascimento'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-thumbs-up" color="primary"></mat-icon>
                </button>

                <button mat-icon-button matSuffix *ngIf="isFieldAproved('birth')"
                  [attr.aria-label]="'Nascimento Verificado'">
                  <mat-icon class="input-icon" fontSet="fa" fontIcon="fa-check" color="accent"></mat-icon>
                </button>

                <mat-datepicker touchUi #birthPicker></mat-datepicker>
              </mat-form-field>


              <div class="expiration"
                *ngIf="(!entity.validated && isValidator) || (entity.validated && entity.validation_expires)">
                <mat-form-field floatLabel="true" class="full-width">
                  <input matInput [readonly]="entity.validated" placeholder="Programar Expiração"
                    formControlName="validation_expires" name="validation_expires" [matDatepicker]="expirationPicker">
                  <mat-datepicker touchUi #expirationPicker></mat-datepicker>
                </mat-form-field>
              </div>


            </form>

          </div>

        </mat-card>


        <div class="profile-picture-holder" *ngIf="profileImage">

          <gio-image-view-advanced [src]="profileImage.photo_url" (closed)="profileImage = null">

            <ng-container buttons-start *ngIf="canValidate && !isFieldAproved('photo_url') && !isFieldRejected('photo_url')">
              <button mat-icon-button>
                <mat-icon fontSet="fa" fontIcon="fa-thumbs-down" (click)="rejectField('photo_url')"></mat-icon>
              </button>
            </ng-container>

            <ng-container buttons-end  *ngIf="canValidate && !isFieldAproved('photo_url') && !isFieldRejected('photo_url')">
              <div class="full-size d-flex flex-end flex-justify-end" >
                <button mat-icon-button>
                  <mat-icon fontSet="fa" fontIcon="fa-thumbs-up" (click)="aproveField('photo_url')"></mat-icon>
                </button>
              </div>
            </ng-container>


          </gio-image-view-advanced>
        </div>



      </div>

      <div class="support-info">

        <ng-container *ngIf="!document">

          <div class="documents">
            <mat-card class="group mat-elevation-z2">
              <div class="group-header">
                <div class="group-title icon">
                  <span>Documentos</span>
                </div>
              </div>
              <div class="group-data">

                <ng-container *ngIf="documents && documents.length >0">

                  <table class="table">
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Publicado</th>
                        <th>Validade</th>
                        <th>Abrir</th>
                        <th>status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let _document of documents">
                        <td class="text-center">{{_document.document_type.name}}</td>
                        <td class="text-center">{{_document.created_at | date:'dd/MM/yyyy'}}</td>
                        <td class="text-center">{{_document.expires | date: 'dd/MM/yyyy'}}</td>
                        <!-- <td class="text-center">

                      <button mat-icon-button color="warn" (click)="rejectDocument(_document)">
                        <mat-icon fontSet="fa" fontIcon="fa-thumbs-down" color="warn"></mat-icon>
                      </button>


                    </td> -->
                        <td class="text-center">
                          <button mat-icon-button color="accent" (click)="openDocument(_document)">
                            <mat-icon color="accent">visibility</mat-icon>
                          </button>

                        </td>
                        <td class="text-center">
                          <button mat-icon-button color="warn" *ngIf="isDocumentRejected(_document)">
                            <mat-icon color="accent" fontSet="fa" fontIcon="fa-times"></mat-icon>
                          </button>

                          <button mat-icon-button color="primary" *ngIf="isDocumentProved(_document)">
                            <mat-icon color="accent" fontSet="fa" fontIcon="fa-check"></mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </ng-container>

                <ng-container *ngIf="!documents || documents.length == 0">
                  <div class="no-record font-red">
                    nenhum documento publicado.
                  </div>
                </ng-container>


              </div>
            </mat-card>


          </div>

          <div class="relations" *ngIf="['athletes', 'contributors'].includes(entity.source_name)">
            <mat-card class="group mat-elevation-z2">
              <div class="group-header">
                <div class="group-title">Clubes</div>
              </div>
              <div class="group-data">

                <ng-container *ngIf="relations && relations.length >0">

                  <table class="table">
                    <thead>
                      <tr>
                        <th colspan="2">Clube</th>
                        <th>Início</th>
                        <th>Fim</th>
                        <th>Validado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let _relation of relations">
                        <td class="text-center">
                          <app-image-view [src]="_relation.parent.photo_url" [imageSize]="36"></app-image-view>
                        </td>
                        <td class="text-left">{{_relation.parent.nickname}}</td>
                        <td class="text-center">{{_relation.started_at | date:'dd/MM/yyyy'}}</td>
                        <td class="text-center">{{_relation.ended_at | date:'dd/MM/yyyy'}}</td>
                        <td class="text-center">
                          <button mat-icon-button *ngIf="!_relation.parent.validated">
                            <mat-icon color="warn" fontSet="fa" fontIcon="fa-times"></mat-icon>
                          </button>

                          <button mat-icon-button *ngIf="_relation.parent.validated">
                            <mat-icon color="accent" fontSet="fa" fontIcon="fa-check"></mat-icon>
                          </button>

                        </td>
                      </tr>
                    </tbody>
                  </table>



                </ng-container>

                <ng-container *ngIf="!relations && relations.length == 0">
                  <div class="no-record">
                    nenhum histórico disponível.
                  </div>
                </ng-container>


              </div>
            </mat-card>
          </div>

          <div class="permissions">
            <mat-card class="group mat-elevation-z2">
              <div class="group-header">
                <div class="group-title">Usuários</div>
              </div>
              <div class="group-data">

                <ng-container *ngIf="users && users.length >0">

                  <table class="table">
                    <thead>
                      <tr>
                        <th colspan="2">Usuário</th>
                        <th>Desde</th>
                        <th>Dono</th>
                        <th>Validado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let _user of users">
                        <td class="text-center">
                          <app-image-view [src]="_user.photo_url" [imageSize]="36"></app-image-view>
                        </td>
                        <td class="text-left">{{_user.name}}</td>
                        <td class="text-center">{{_user.permissions.created_at | date:'dd/MM/yyyy'}}</td>
                        <td class="text-center">{{_user.permissions.permissions.owner ? 'Sim' : 'Não'}}</td>

                        <td class="text-center">
                          <button mat-icon-button *ngIf="!_user.validated">
                            <mat-icon color="warn" fontSet="fa" fontIcon="fa-times"></mat-icon>
                          </button>

                          <button mat-icon-button *ngIf="_user.validated">
                            <mat-icon color="accent" fontSet="fa" fontIcon="fa-check"></mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>



                </ng-container>

                <ng-container *ngIf="!users && users.length == 0">
                  <div class="no-record">
                    Conta sem usuário para gerenciamento
                  </div>
                </ng-container>


              </div>
            </mat-card>
          </div>

          <div class="permissions">
            <mat-card class="group mat-elevation-z2">
              <div class="group-header">
                <div class="group-title">Histórico</div>
              </div>
              <div class="group-data">

                <ng-container *ngIf="history && history.length >0">

                  <table class="table">
                    <thead>
                      <tr>
                        <th>Data</th>
                        <th colspan="2">Validador</th>
                        <th colspan="2">Agente</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of history" (click)="showValidation(item)">
                        <td>{{item.created_at | date: 'dd/MM/yyyy'}}</td>
                        <td class="text-center">
                          <app-image-view [src]="item.behalf.photo_url" [imageSize]="36"></app-image-view>
                        </td>
                        <td class="text-left">{{item.behalf.nickname}}</td>
                        <td class="text-center">
                          <app-image-view [src]="item.user.photo_url" [imageSize]="36"></app-image-view>
                        </td>
                        <td class="text-left">{{item.user.nickname}}</td>
                        <td class="text-center">

                          <mat-icon color="accent" *ngIf="item.validated">verified_user</mat-icon>
                          <mat-icon color="warn" *ngIf="!item.validated">highlight_off</mat-icon>
                        </td>
                      </tr>



                    </tbody>
                  </table>



                </ng-container>

                <ng-container *ngIf="!users && users.length == 0">
                  <div class="no-record">
                    Conta sem usuário para gerenciamento
                  </div>
                </ng-container>


              </div>
            </mat-card>


          </div>



        </ng-container>


        <div class="document" *ngIf="document">

          <gio-image-view-advanced #documentImage *ngIf="document && document.mime_type.startsWith('image');"
            [src]="document.path" (closed)="document = null">

            <ng-container *ngIf="canValidate" buttons-start>
              <div class="full-size flex">

                <button mat-icon-button (click)="rejectDocument(document)">
                  <mat-icon fontSet="fa" fontIcon="fa-thumbs-down"></mat-icon>
                </button>

              </div>
            </ng-container>

            <ng-container *ngIf="canValidate" buttons-end>
              <div class="full-size d-flex flex-end flex-justify-end">
                <button mat-icon-button>
                  <mat-icon fontSet="fa" fontIcon="fa-thumbs-up" (click)="aproveDocument(document)"></mat-icon>
                </button>
              </div>
            </ng-container>

          </gio-image-view-advanced>


          <ng-container *ngIf="document && !document.mime_type.startsWith('image');">
            <div class="embed-holder">
              <div class="document-close">
                <button mat-fab (click)="document = null">
                  <mat-icon class="fab-icon">clear</mat-icon>
                </button>
              </div>
              <embed class="emdeded" name="plugin" id="plugin" [src]="previewURL" [type]="document.mime_type"
                internalinstanceid="5">

              <div class="document-actions" *ngIf="!entity.validated && canValidate">
                <button mat-fab color="warn">
                  <mat-icon class="fab-icon" fontSet="fa" fontIcon="fa-thumbs-down" (click)="rejectDocument(document)">
                  </mat-icon>
                </button>
                <button mat-fab color="primary">
                  <mat-icon class="fab-icon" fontSet="fa" fontIcon="fa-thumbs-up" (click)="aproveDocument(document)">
                  </mat-icon>
                </button>

              </div>
            </div>

          </ng-container>
        </div>


      </div>
    </div>



  </div>

  <div class="actions">
    <button mat-raised-button color="warn" (click)="close()">FECHAR</button>
    <button mat-raised-button color="accent" *ngIf="canValidate && !entity.validated && isValidator"
      (click)="sendRejections()">REJEITAR</button>
    <button mat-raised-button color="primary" *ngIf="canValidate && !entity.validated && isValidator"
      (click)="save()">APROVAR</button>
  </div>

</div>

<div class="reject" *ngIf="rejecting">

  <mat-card>
    <mat-card-header>
      <app-image-view mat-card-avatar
        [ngClass]="{validated:isFieldAproved('photo_url'), rejected:isFieldRejected('photo_url')}"
        [src]="entity.photo_url" radius="100%" imageSize="40" (click)="profileImage=entity">
      </app-image-view>

      <mat-card-title>{{entity.name}}</mat-card-title>
      <mat-card-subtitle>{{entity.nickname}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <p>Informe o motivo para a rejeição deste campo.</p>
      <div>
        <form *ngIf="form" [formGroup]="formRejection" #cForm="ngForm" novalidate
          (keydown.enter)="$event.preventDefault()">
          <mat-form-field floatLabel="true" class="full-width"
            [ngClass]="{validated:isFieldAproved('name'), rejected:isFieldRejected('name')}" [color]="'primary'">

            <textarea matInput placeholder="Motivo da rejeição" formControlName="reason" name="reason">

            </textarea>

          </mat-form-field>

        </form>
      </div>
    </mat-card-content>
    <mat-card-actions class="card-actions">
      <button mat-button (click)="rejecting = null">CANCELAR</button>
      <button mat-button (click)="appendRejection()">SALVAR</button>
    </mat-card-actions>

  </mat-card>

</div>

<div class="alert" *ngIf="showAlert">
  <mat-card>
    <mat-card-header>
      <app-image-view mat-card-avatar
        [ngClass]="{validated:isFieldAproved('photo_url'), rejected:isFieldRejected('photo_url')}"
        [src]="entity.photo_url" radius="100%" imageSize="40" (click)="profileImage=entity">
      </app-image-view>

      <mat-card-title>{{entity.name}}</mat-card-title>
      <mat-card-subtitle>{{entity.nickname}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <p>Mensagem a ser enviada à entidade</p>
      <div>
        <form *ngIf="formAlert" [formGroup]="formAlert" novalidate (keydown.enter)="$event.preventDefault()">
          <mat-form-field floatLabel="true" class="full-width">

            <textarea matInput class="text-area" placeholder="Mensagem a ser enviada" formControlName="message"
              name="message">

            </textarea>

          </mat-form-field>

        </form>
      </div>
    </mat-card-content>
    <mat-card-actions class="card-actions">
      <button mat-button (click)="showAlert = false">CANCELAR</button>
      <button mat-button (click)="sendAlert()">ENVIAR</button>
    </mat-card-actions>

  </mat-card>
</div>

<div class="full-size" *ngIf="loading && !error">
  <gio-loading-page [subtitle]="loading"></gio-loading-page>
</div>

<gio-error-card-page *ngIf="error" [error]="error" buttonText="fechar" (buttonClick)="dialogRef.close()">
</gio-error-card-page>
